webpackJsonp([39],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return floatMenu; });
/**
 * Created by lycheng on 2017/12/4.
 * 浮动导航，默认是右边悬浮，需要改变位置可使用
 * floatMenu.config.position重新赋值
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    $container: $('html,body'),
    checkedClass: 'nav-checked',
    position: {
      top: {
        position: 'absolute',
        top: '600px',
        bottom: 'auto'
      },
      middle: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      },
      bottom: {
        // position: 'fixed',
        // top: '500px',
        // bottom: '0'
      },
      minTop: {
        position: 'fixed',
        top: '550px',
        bottom: 'auto'
      },
      minBottom: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      }
    }
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-service-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
    window.onscroll();
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-service-nav-fall');
      var $navItem = $('.js-service-nav-fall li');
      var targets = [];
      var i = 0;
      var position = floatMenu.config.position;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }

      if (top >= tops[0]) {
        if (top + $navCon.height() + floatMenu.config.top > tops[tops.length - 1]) {
          $navCon.css(position.bottom);
        } else {
          $navCon.css(position.middle);
        }
      } else {
        $navCon.css(position.top);
      }
    }

  }
};


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceQA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serviceTopbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_api_user__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_utils_login__ = __webpack_require__(7);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */








function serviceQA() {
  var $serviceQA = $('.service-item-qa');
  // 问答题超过两组时隐藏超出部分
  if ($serviceQA.length) {
    var oLi = $serviceQA.find('li');
    if (oLi.length <= 4) {
      $('.service-qa-more').hide();
    }
    for (var i = 0; i < oLi.length; i++) {
      if (i >= 4) {
        oLi.eq(i).hide();
      }
    }
  }
  // 点击查看更多显示超出部分
  $('.service-qa-more').click(function () {
    var oLi = $serviceQA.find('li');
    oLi.show();
    $(this).hide();
  });
}

function serviceTopbar() {
  var $serviceTopbar = $('.service-topbar');
  if ($serviceTopbar.length) {
    $(window).scroll(function () {
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 450) {
        $('.service-topbar').show();
      } else {
        $('.service-topbar').hide();
      }
    });
  }
}

// 滑动到产品价格
function scrollToPrice() {
  $('html,body').animate({
    scrollTop: $('.service-item-price').offset().top - 100
  }, 1e3);
}

function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    if (serviceKey === 'face' || serviceKey === 'isv' || serviceKey === 'xpush') {
      serviceKey = 'base';
    }
    Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["g" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_0_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.to-price').click(function () {
    scrollToPrice();
  });
  // 滑动到产品价格
  var hash = location.hash;
  if (hash === '#price') {
    scrollToPrice();
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["d" /* getQueryString */])('target') === 'price') {
    scrollToPrice();
  }
}
bindEvent();
Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
if ($('.js-service-nav-fall').length) {
  __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__["a" /* floatMenu */].init();
}



/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getServiceOpenApps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMobileappSdkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return openService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return openOcrService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return openNewFrameService; });
/* unused harmony export webTTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mtranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return lexicalAnalysist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOtsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getItsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return productKesa; });
/* unused harmony export getOnlineAudioSrc */
/* unused harmony export getVoiceAudioSrc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIatSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIatLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTtsSpeakList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTtsSign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__ = __webpack_require__(6);
/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */




/**
 * 获取用户app
 * @param servicesId
 * @returns {Promise}
 */
function getServiceOpenApps(servicesId, getAppUrl) {
  return new Promise(function (resolve, reject) {
    var url = '/herapi/user/get_app_list_by_service?service_id=' + btoa(servicesId);
    jQuery.ajax({
      url: getAppUrl || url,
      type: 'get',
      dataType: 'json',
      success: function success(data) {
        resolve({
          code: 0,
          data: data
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取用户app
 * 代替getServiceOpenApps
 */
function getApps() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getAppList',
      type: 'get',
      dataType: 'json',
      cache: false,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {
        resolve({});
      }
    });
  });
}

/**
 * 开通服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'mycloud/app/accessService',
      dataType: 'json',
      data: {
        'app_id': appId,
        'service': servicesId
      },
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 开通ocr服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openOcrService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/app/jsonp/service/add',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 开通新框架服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openNewFrameService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/webapi/jsonp/addService/v1',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 语音合成的接口
 * @param params：
 * {
 *   vcn: aisxping,
 *   vol: 7,
 *   spd: medium,
 *   textPut: '', // 输入的文本
 * }
 * @returns {Promise}
 */
function webTTS(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'post',
      url: '/herapi/solution/synthesis',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function mtranslate(params) {
  // {
  //   fromLang: trans.data.source,
  //     toLang: trans.data.dist,
  //   originText: text
  // }
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/translate',
      type: 'post',
      data: params,
      success: function success(result) {
        // result.code = result.flag ? 0 : -1
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取开放统计的sdkList
 * @returns {Promise}
 */
function getMobileappSdkList() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/getSdkList',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 词法分析接口
 * @returns {Promise}
 */
function lexicalAnalysist(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/index/webltp',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译niutrans体验接口
 * @returns {Promise}
 */
function getOtsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/ots',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译体验接口
 * @returns {Promise}
 */
function getItsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/its',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 关键词提取type传：ke
 * 如果是调用情感分析type传：sa
 * 关键词 && 情感分析接口
 * @returns {Promise}
 */
function productKesa(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/kesa',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取在线语音合成的音频src
 * @returns {Promise}
 */
function getOnlineAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/synthesis/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getVoiceAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/dictation/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取极验数据进行初始化
 * @returns {Promise}
 */
function getValidate() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/plug/validate',
      type: 'get',
      cache: false,
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}
/**
 * 获取听写websocket链接
 * @returns {Promise}
 */
function getIatSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getIatLanguage() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_language_list',
      type: 'post',
      dataType: 'json',
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取合成websocket链接
 * @returns {Promise}
 */
function getTtsSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 合成体验发音人参数列表获取接口
 * @param grade 发音人等级（默认是0，0特色发音人，1精品发音人）
 * @returns {Promise}
 */
function getTtsSpeakList(_ref) {
  var _ref$grade = _ref.grade,
      grade = _ref$grade === undefined ? 0 : _ref$grade;

  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_language_list',
      type: 'post',
      dataType: 'json',
      data: {
        grade: grade
      },
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}



/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-polyfill@6.26.0@babel-polyfill/lib/index.js
var lib = __webpack_require__(1);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// CONCATENATED MODULE: ./src/js/api/package.js
/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */



/**
 * 判断package需要进行的认证状态
 * @param packageId
 * @param async
 * @returns {Promise}
 */
function getPackageCerType(_ref, _ref2) {
  var packageId = _ref.packageId;
  var _ref2$async = _ref2.async,
      async = _ref2$async === undefined ? true : _ref2$async;

  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/package/getPackageCerType',
      type: 'get',
      dataType: 'json',
      async: async,
      cache: false,
      data: {
        packageId: packageId
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}


// EXTERNAL MODULE: ./src/js/libs/utils-login.js + 5 modules
var utils_login = __webpack_require__(7);

// CONCATENATED MODULE: ./src/js/libs/utils-services-buy.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goServiceBuy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return justGoServiceBuy; });
/**
 * Created by jingzhao5 on 2018/02/28.
 */







/**
 * 示例
 let params = {
  wareId: '2001',
  packageId: packageId,
  serviceName: '离线语音合成',
  businessId: 'aisound'
}
 */

function goServiceBuy(urlParams) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$btnStr = _ref.btnStr,
      btnStr = _ref$btnStr === undefined ? '购买' : _ref$btnStr,
      callback = _ref.callback;

  // -1不需要认证（免费），0默认值需要进行认证，1需要进行个人以上认证（含个人企业），2需要进行企业以上认证
  Promise.all([Object(user["c" /* checkUserCertificate */])({ async: false }), getPackageCerType({
    packageId: urlParams.packageId || urlParams.selectPackageId
  }, { async: false })]).then(function (values) {
    var url = prod["a" /* config */].CONSOLE + 'sale/buy?';
    for (var p in urlParams) {
      if (urlParams[p]) {
        url += p + '=' + urlParams[p] + '&';
      }
    }
    url = url.substring(0, url.length - 1);

    var certificateResult = values[0];
    var packageResult = values[1];
    if (packageResult.code === undefined) {
      callback ? callback(url) : window.open(url);
      return;
    }
    if (certificateResult.code === undefined) {
      return;
    }
    if (certificateResult.code === 80000 || certificateResult.code === 80003) {
      Object(utils_login["b" /* showLoginModal */])();
      return;
    }
    var certificateData = certificateResult.data;
    var packageData = packageResult.data;
    // 不需要实名认证
    if (packageData === -1) {
      callback ? callback(url) : window.open(url);
      return;
    }
    // 下面都是需要认证
    // 需要企业认证
    if (packageData === 2) {
      // 认证是个人认证
      if (certificateData.type !== 'BUSINESS_TEAM' && certificateData.type !== 'COMPANY') {
        // 弹出去企业认证框
        jAlert('\u60A8\u8FD8\u672A\u5B8C\u6210\u4F01\u4E1A\u5B9E\u540D\u8BA4\u8BC1\uFF0C\u8BA4\u8BC1\u540E\u53EF' + btnStr + '~', function (flag) {
          if (flag) {
            window.open(prod["a" /* config */].CONSOLE + 'user/authentication');
          }
        }, '去认证');
        return;
      }
    }
    // 未实名认证完成
    if (!certificateData.flag) {
      jAlert('\u60A8\u8FD8\u672A\u5B8C\u6210\u5B9E\u540D\u8BA4\u8BC1\uFF0C\u8BA4\u8BC1\u540E\u53EF' + btnStr + '~', function (flag) {
        if (flag) {
          window.open(prod["a" /* config */].CONSOLE + 'user/authentication');
        }
      }, '去认证');
      return;
    }
    // 实名认证满足要求
    callback ? callback(url) : window.open(url);
  }).catch(function (e) {
    console.log(e);
  });
}

function justGoServiceBuy(urlParams) {
  var url = prod["a" /* config */].CONSOLE + 'sale/buy?';
  for (var p in urlParams) {
    if (urlParams[p]) {
      url += p + '=' + urlParams[p] + '&';
    }
  }
  url = url.substring(0, url.length - 1);
  window.open(url);
}



/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(5);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */





function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  var $suspension = $(".affix");
  var $backTop = $(".affix-bottom");
  var $panelSuggest = $(".affix-panel-content__suggest");
  var $panelApplet = $(".affix-panel-content__applet");
  var $panelAdvice = $(".affix-panel-content__advice");
  var $iframe = $(".affix-panel-content__iframe");
  var timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    user["e" /* getUserinfo */]().then(function (res) {
      if (res.code === 80000) {
        var jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = prod["a" /* config */].PASSPORT_NEW + "/login?jump=" + jumpBack;
      } else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*');
      }
    });
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    user["e" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["e" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + "/login?jump=" + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function setIframe(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
};
$(function () {
  window.addEventListener("message", function (e) {
    if (e.data.type === 'dom') {
      var data = e.data.data;

      var width = data.width;
      var height = data.height + 12;
      methods.setIframe(width, height);
    }
    if (e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show');
    }
  });
});


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_niutrans_scss__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_niutrans_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_services_niutrans_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils_services__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_libs_utils_services_buy__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_api_services__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_libs_gt__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_libs_gt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_libs_gt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_base64__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_base64__);









var trans = {
  config: {},
  data: {
    select: '',
    from: 'auto',
    fromText: '自动检测',
    to: 'en',
    toText: '英语',
    languageList: {
      'sq': '阿尔巴尼亚语',
      'ar': '阿拉伯语',
      'am': '阿姆哈拉语',
      'az': '阿塞拜疆语',
      'ee': '埃维语',
      'ga': '爱尔兰语',
      'et': '爱沙尼亚语',
      'om': '奥罗莫语',
      'os': '奥赛梯语',
      'tpi': '巴布亚皮钦语',
      'ba': '巴什基尔语',
      'eu': '巴斯克语',
      'be': '白俄罗斯语',
      'mww': '白苗文',
      'bg': '保加利亚语',
      'bi': '比斯拉马语',
      'bem': '别姆巴语',
      'is': '冰岛语',
      'pl': '波兰语',
      'nb': '博克马尔语',
      'tn': '茨瓦纳语',
      'ts': '聪加语',
      'bs': '波斯尼亚语',
      'fa': '波斯语',
      'tt': '鞑靼语',
      'da': '丹麦语',
      'de': '德语',
      'ru': '俄语',
      'fr': '法语',
      'fil': '菲律宾语',
      'fj': '斐济语',
      'fi': '芬兰语',
      'fy': '弗里西语',
      'kg': '刚果语',
      'km': '高棉语',
      'jy': '格鲁吉亚语',
      'gu': '古吉拉特语',
      'ka': '哈萨克语',
      'kk': '哈萨克语（西里尔）',
      'ht': '海地克里奥尔语',
      'ko': '韩语',
      'ha': '豪萨语',
      'nl': '荷兰语',
      'ky': '吉尔吉斯语',
      'gl': '加利西亚语',
      'ca': '加泰罗尼亚语',
      'cs': '捷克语',
      'kn': '卡纳达语',
      'kek': '凯克其语',
      'co': '科西嘉语',
      'otq': '克雷塔罗奥托米语',
      'hr': '克罗地亚语',
      'ku': '库尔德语',
      'la': '拉丁语',
      'lv': '拉脱维亚语',
      'lo': '老挝语',
      'lt': '立陶宛语',
      'ln': '林加拉语',
      'rn': '隆迪语',
      'lg': '卢干达语',
      'lb': '卢森堡语',
      'rw': '卢旺达语',
      'ro': '罗马尼亚语',
      'mg': '马尔加什语',
      'mt': '马耳他语',
      'mr': '马拉地语',
      'ml': '马拉雅拉姆语',
      'ms': '马来语',
      'mhr': '马里语',
      'mk': '马其顿语',
      'mi': '毛利语',
      'mn': '蒙古语（西里尔）',
      'bn': '孟加拉语',
      'my': '缅甸语',
      'af': '南非荷兰语',
      'xh': '南非科萨语',
      'zu': '南非祖鲁语',
      'ne': '尼泊尔语',
      'no': '挪威语',
      'pap': '帕皮阿门托语',
      'pa': '旁遮普语',
      'pt': '葡萄牙语',
      'ps': '普什图语',
      'ny': '齐切瓦语',
      'tw': '契维语',
      'ja': '日语',
      'sv': '瑞典语',
      'sm': '萨摩亚语',
      'sr': '塞尔维亚语',
      'crs': '塞舌尔克里奥尔语',
      'st': '塞索托语',
      'sg': '桑戈语',
      'si': '僧伽罗语',
      'mrj': '山地马里语',
      'eo': '世界语',
      'sk': '斯洛伐克语',
      'sl': '斯洛文尼亚语',
      'sw': '斯瓦希里语',
      'gd': '苏格兰盖尔语',
      'so': '索马里语',
      'tg': '塔吉克语',
      'ty': '塔希提语',
      'te': '泰卢固语',
      'ta': '泰米尔语',
      'th': '泰语',
      'to': '汤加语',
      'tig': '提格雷语',
      'tr': '土耳其语',
      'tk': '土库曼语',
      'war': '瓦瑞语',
      'cy': '威尔士语',
      'uy': '维吾尔语',
      'udm': '乌德穆尔特语',
      'ur': '乌尔都语',
      'uk': '乌克兰语',
      'uz': '乌兹别克语',
      'es': '西班牙语',
      'he': '希伯来语',
      'el': '希腊语',
      'haw': '夏威夷语',
      'sd': '信德语',
      'hu': '匈牙利语',
      'sn': '修纳语',
      'ceb': '宿务语',
      'hy': '亚美尼亚语',
      'ig': '伊博语',
      'it': '意大利语',
      'yi': '意第绪语',
      'hi': '印地语',
      'su': '印尼巽他语',
      'id': '印尼语',
      'jv': '印尼爪哇语',
      'en': '英语',
      'yua': '尤卡坦玛雅语',
      'yo': '约鲁巴语',
      'vi': '越南语',
      'yue': '（粤）广东话',
      'ti': '藏语',
      'zh': '中文（简体）',
      'cht': '中文（繁体）',
      'auto': '自动检测'
    }
  },
  bindEvent: function bindEvent() {
    var self = this;
    $(document).on('click', function () {
      $('.Lbox').hide();
    });
    $(document).find('.trans-select-button').on('click', function (e) {
      e.stopPropagation();
      self.data.select = $(this).attr('value');
      $(document).find('.Lbox-table li, .frequently-used-language li').removeClass('selected');
      if (self.data.select === 'trans_from_lan') {
        $('.frequently-used-language .auto-select').show();
        $('.Lbox-table, .frequently-used-language').find('[value=' + self.data.to + ']').addClass('selected');
      } else {
        $('.frequently-used-language .auto-select').hide();
        $('.Lbox-table, .frequently-used-language').find('[value=' + self.data.from + ']').addClass('selected');
      }
      $('.Lbox').show();
    });
    $(document).find('.Lbox').hover(function () {}, function () {
      $('.Lbox').hide();
    });
    $(document).find('.Lbox-table li, .frequently-used-language li').on('click', function (e) {
      e.stopPropagation();
      if ($(this).hasClass('selected')) {
        return false;
      }
      self.methods.selectLanguage($(this).attr('value'), $(this).html());
    });
    $(document).find('#trans_text').on('keyup', function () {
      var len = $('#trans_text').val().length;
      $(document).find('.trans-text-num').empty().html(len + '/800');
    });
    $(document).find('.form-to-icon').on('click', function () {
      if (self.data.from === 'auto') return false;
      $('#trans_text').val('');
      $(document).find('.io-output .output').empty();
      self.methods.exchangeLanguage();
    });
  },
  methods: {
    selectLanguage: function selectLanguage(val, text) {
      $('.Lbox').hide();
      if (trans.data.select === 'trans_from_lan') {
        trans.data.from = val;
        trans.data.fromText = text;
        $('.trans-form-button span').replaceWith('<span>' + text + '</span>');
      } else {
        trans.data.to = val;
        trans.data.toText = text;
        $('.trans-to-button span').replaceWith('<span>' + text + '</span>');
      }
    },
    exchangeLanguage: function exchangeLanguage() {
      var temp = trans.data.from;
      var tempText = trans.data.fromText;
      trans.data.from = trans.data.to;
      trans.data.to = temp;
      trans.data.fromText = trans.data.toText;
      trans.data.toText = tempText;
      $('.trans-form-button span').replaceWith('<span>' + trans.data.fromText + '</span>');
      $('.trans-to-button span').replaceWith('<span>' + trans.data.toText + '</span>');
    },
    getResult: function getResult(val) {
      $.mask();
      $(document).find('.io-output .output').empty();
      var params = {
        from: trans.data.from,
        to: trans.data.to,
        text: __WEBPACK_IMPORTED_MODULE_7_js_base64__["Base64"].encode($.trim($('#trans_text').val())),
        challenge: val.geetest_challenge,
        validate: val.geetest_validate,
        seccode: val.geetest_seccode
      };
      Object(__WEBPACK_IMPORTED_MODULE_5_js_api_services__["f" /* getOtsResult */])(params).then(function (res) {
        $.mask('hide');
        if (res.data === null) {
          return;
        }
        if (res.code === 0 || res.code === '0') {
          trans.data.from = res.data.result.from;
          trans.data.fromText = trans.data.languageList[trans.data.from];
          $('.trans-form-button span').replaceWith('<span>' + trans.data.fromText + '</span>');
          var str = '<div class="result">' + res.data.result.trans_result.dst + '</div>';
          $(document).find('.io-output .output').html(str);
        } else {
          $.alerts.alert(res.desc);
        }
      }).catch(function (errMsg) {
        $.mask('hide');
        $.alerts.alert(errMsg);
      });
    },

    // 极验Api1
    geetestApi1: function geetestApi1() {
      var self = trans;
      $.ajax({
        url: '/herapi/plug/validate?t=' + new Date().getTime(),
        type: 'get',
        dataType: 'json',
        success: function success(data) {
          // 调用 initGeetest 进行初始化
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
          initGeetest({
            // 以下 4 个配置参数为必须，不能缺少
            gt: data.data.gt,
            challenge: data.data.challenge,
            offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机

            product: 'bind', // 产品形式，包括：float，popup
            width: '300px'
            // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
          }, function (captchaObj) {
            captchaObj.onReady(function () {}).onSuccess(function () {
              self.result = captchaObj.getValidate();
              if (!self.result) {
                return $.alerts.alert('请完成验证');
              }
              trans.methods.getResult(self.result);
            });
            $('#taste-button').click(function () {
              var text = $.trim($('#trans_text').val());
              if (!text) {
                $.alerts.alert('请输入需要翻译的内容');
              } else {
                captchaObj.verify();
              }
            });
          });
        }
      });
    }
  },
  init: function init() {
    this.bindEvent();
  }
};

$(function () {
  trans.init();
  trans.methods.geetestApi1();
  $('.answer-table .buy-btn').click(function () {
    var packageId = $(this).attr('package-id');
    var params = {
      wareId: '7001',
      packageId: packageId,
      serviceName: '机器翻译',
      businessId: 'ots'
    };
    Object(__WEBPACK_IMPORTED_MODULE_4_js_libs_utils_services_buy__["a" /* goServiceBuy */])(params);
  });
  Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils_services__["a" /* serviceQA */])();
  Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils_services__["b" /* serviceTopbar */])();
});

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[718]);


// WEBPACK FOOTER //
// js/services/niutrans.a894414f17b70f51deb5.bundle.js